class IngredientsGlossary extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.onTrigger = this.onTrigger.bind(this)

    this.els?.trigger?.elements.forEach(triggerEl => {
      this.listeners.add(triggerEl, 'click', this.onTrigger)
    })
  }

  onTrigger (event) {
    const triggerEl = event.target.closest(this.els?.trigger?.selector)
    const characters = triggerEl.dataset.characters.split(',')

    if (!triggerEl) return

    this.els.trigger.elements.forEach(trigger => {
      trigger.setAttribute('aria-pressed', trigger === triggerEl)
    })

    this.els.accordion.elements.forEach(accordionEl => {
      const currentState = characters.includes(accordionEl.dataset.character)
      accordionEl.setAttribute('aria-hidden', !currentState)
    })
  }
}

if (!customElements.get('ingredients-glossary')) {
  customElements.define('ingredients-glossary', IngredientsGlossary)
}
